import React from 'react';

import CallToAction from '../../CallToAction';

import { Container, Title, Wrapper } from '../styles/SearchCard.styled';
import Icon from '../../../molecules/Icon';

const typeMap = {
  website_page: 'Site Page',
  blog_post: 'Blog',
  customer_success_story: 'Success Story',
  download: 'Download',
  event_post: 'Event',
  integration: 'Integration',
  learning_post: 'Article',
  partnership: 'Partner',
  podcast: 'Podcast',
  product_release: 'Product Release',
  template_collection: 'Template',
};

const SearchCard = ({ type, slug, title, description }) => (
  <Container>
    <Icon id="file-lines" width="22px" height="22px" />
    <Wrapper>
      <Title>
        {title && (
          <p
            className="title"
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        )}
        {type && <p className="type">{typeMap[type || 'website_page']}</p>}
      </Title>
      {description && (
        <p
          className="description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </Wrapper>
    {slug && <CallToAction variant="Clickable" url={slug} />}
  </Container>
);

export default SearchCard;
